import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Table, Pagination, Popconfirm, Space, Row, Col, Modal, message, Upload, Select, Tree } from 'antd';
import { DeleteOutlined, FormOutlined, RedoOutlined, SearchOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import _axios from '../unit/axios';

function Auth() {

    const [user, setUser] = useState([]);
    const [auth, setAuth] = useState([]);
    let isinit = false;
    useEffect(() => {
        if (!isinit) {
            var user = JSON.parse(localStorage.getItem('user'));
            setUser(user);
            if (user.id != '3') { 
                setAuth(JSON.parse(localStorage.getItem('auth') || '[]'));
            }
            getList();
            isinit = true;
        }

    }, [])

    const [loading, setLoading] = useState(false);
    const seachource = useRef({});
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [searchForm] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const getList = async () => {
        var p = {
            page,
            size,
            ...seachource.current,
        }
        setLoading(true);
        _axios.get('/api.v1/role/list', { params: p }).then(res => {
            setList(res.data.list || []);
            setTotal(res.data.total || 0);
            setLoading(false);
        }).catch(err => {
            console.log(err)
            setLoading(false);
        })
    }

    useEffect(() => {
        getList();
    }, [page, size])

    const onFinish = (values) => {
        console.log('Success:', values);
        for (const key in values) {
            if (values[key] === null || values[key] === undefined) {
                delete values[key];
            }
        }
        seachource.current = values;
        page == 1 ? getList() : setPage(1);
    };

    const columns = [{
        title: '角色名称',
        dataIndex: 'name',
        key: 'name',
    }, {
        title: '操作',
        key: 'action',
        width: '150px',
        align: 'center',
        render: (_, record) => {
            return <Space size="middle">
                {(user.id == '3' || auth.includes('cate1-edit')) && <Button color="primary" variant="solid" size="small" onClick={() => showModal('edit', record)}><FormOutlined />修改</Button>}
                {(user.id == '3' || auth.includes('cate1-del')) && <Popconfirm title="系统提示" description="确定删除该数据吗？" okText="确定" cancelText="取消" onConfirm={() => deleteRow(record)}>
                    <Button color="danger" variant="solid" size="small" disabled={loading}><DeleteOutlined />删除</Button>
                </Popconfirm>}
            </Space>
        },
    }]
    
    const initialTreeData = [{
        key: 'space', title: '统计首页',
    },{
        key: 'user', title: '学生账号',
        children: [{
            key: 'user-add', title: '新增',
        }, {
            key: 'user-edit', title: '修改',
        }, {
            key: 'user-del', title: '删除',
        }]
    }, {
        key: 'cate1', title: '题库一级分类',
        children: [{
            key: 'cate1-add', title: '新增',
        }, {
            key: 'cate1-edit', title: '修改',
        }, {
            key: 'cate1-del', title: '删除',
        }]
    }, {
        key: 'cate2', title: '题库二级分类',
        children: [{
            key: 'cate2-add', title: '新增',
        }, {
            key: 'cate2-edit', title: '修改',
        }, {
            key: 'cate2-del', title: '删除',
        }]
    }, {
        key: 'question', title: '题目管理',
        children: [{
            key: 'question-add', title: '新增',
        }, {
            key: 'question-edit', title: '修改',
        }, {
            key: 'question-del', title: '删除',
        }]
    }, {
        key: 'answer', title: '答案管理',
        children: [{
            key: 'answer-add', title: '新增',
        }, {
            key: 'answer-edit', title: '修改',
        }, {
            key: 'answer-del', title: '删除',
        }]
    }, {
        key: 'score', title: '成绩管理',
        children: [{
            key: 'score-add', title: '新增',
        }, {
            key: 'score-edit', title: '修改',
        }, {
            key: 'score-del', title: '删除',
        }]
    }, {
        key: 'school', title: '学校管理',
          children: [{
            key: 'school-add', title: '新增',
        }, {
            key: 'school-edit', title: '修改',
        }, {
            key: 'school-del', title: '删除',
        }]
    }, {
        key: 'student', title: '学生管理',
        // children: [{
        //     key: 'student-add', title: '新增',
        // }, {
        //     key: 'student-edit', title: '修改',
        // }, {
        //     key: 'student-del', title: '删除',
        // }]
    }, {
        key: 'setting', title: '系统设置', checkable: false,
        children: [{
            key: 'account', title: '账号管理',
            children: [{
                key: 'account-add', title: '新增',
            }, {
                key: 'account-edit', title: '修改',
            }, {
                key: 'account-del', title: '删除',
            }]
        }, {
            key: 'auth', title: '权限管理',
            children: [{
                key: 'auth-add', title: '新增',
            }, {
                key: 'auth-edit', title: '修改',
            }, {
                key: 'auth-del', title: '删除',
            }]
        }]
    },];

    const [form] = Form.useForm();
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({});
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [treeData, setTreeData] = useState(initialTreeData);  
    // const [videoList, setVideoList] = useState([]);
    const showModal = (type = 'add', row) => {
        var data = { name: '', type };
        if (row) {
            data = Object.assign(data, row);
        }
        var auth = [], expanded = [];
        if (row.rule[0]=='[' && row.rule[row.rule.length - 1] == ']') {
            try {
                auth = JSON.parse(row.rule);
            } catch (error) { 
                console.log(error)
            }
            auth.forEach(item => {
                if (item.indexOf('-') > 0) {
                    var p = item.split('-')[0];
                    expanded.push(p);
                }
            });
            expanded = Array.from(new Set(expanded));
            expanded.push('setting');
        }
        setCheckedKeys(auth);
        setExpandedKeys(expanded);
        setTreeData(JSON.parse(JSON.stringify(initialTreeData)));
        form.setFieldsValue(data);
        setModalData(data);
        setModalShow(true);
    }

    const deleteRow = (row) => {
        setLoading(true);
        _axios.delete('/api.v1/role', { data: { id: row.id } }).then(res => {
            messageApi.open({
                type: 'success',
                content: '删除成功',
            })
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '删除失败',
            })
            setLoading(false);
        })
    }

    const save = () => {
        form.submit();
    }

    const submit = (values) => {
        setLoading(true);
        var p = Object.assign(modalData, values);
        p.rule = JSON.stringify(checkedKeys);
        _axios.put('/api.v1/role', p).then(res => {
            messageApi.open({
                type: 'success',
                content: '提交成功',
            })
            setModalShow(false);
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '提交失败',
            })
            setLoading(false);
        })
    }

    const [checkedKeys, setCheckedKeys] = useState([]);
    const onCheck = (selectedKeys, info) => {
        var t = [info.node.key];
        if (info.node.children) {
            t = t.concat(info.node.children.map(item => item.key));
        }
        if (info.node.checked) {    // 取消
            if (info.node.key.indexOf('-') > 0) {
                var p = info.node.key.split('-')[0];
                t.push(p);
            }
            setCheckedKeys(checkedKeys.filter(item => !t.includes(item)));
        } else {    // 选中
            var t = checkedKeys.concat(t);
            if (info.node.key.indexOf('-') > 0) {
                var p = info.node.key.split('-')[0];
                if (t.includes(`${p}-add`) && t.includes(`${p}-edit`) && t.includes(`${p}-del`)) { 
                    t.push(p);
                }
            }
            t = Array.from(new Set(t));
            setCheckedKeys(t);
        }
    };

    const onExpand = (expandedKeys, info) => {
        setExpandedKeys(expandedKeys)
    }

    return (
        <div style={{ padding: '20px', flex: '1',  }}>
            <Form form={searchForm} onFinish={onFinish} autoComplete="off" layout="inline" style={{ borderBottom: '1px solid #ccc', marginBottom: '20px', display: 'block' }}>
                <Row>
                    <Col span={6} style={{ marginBottom: '20px' }}>
                        <Form.Item label="角色名称" name="name">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ marginBottom: '20px' }}>
                        <Form.Item>
                            <Button onClick={() => { searchForm.resetFields(); }} style={{ marginRight: '12px' }}>
                                <RedoOutlined />重置
                            </Button>
                            <Button color="primary" variant="solid" htmlType="submit" disabled={loading} style={{ marginRight: '12px' }}>
                                <SearchOutlined />查询
                            </Button>
                            {(user.id == '3' || auth.includes('auth-add')) && <Button color="primary" variant="filled" onClick={() => showModal()}>
                                <PlusOutlined />新增
                            </Button>}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Table dataSource={list} columns={columns} pagination={false} rowKey="id"></Table>

            <div style={{ marginTop: '20px' }}>
                <Pagination current={page} pageSize={size} total={total} align='end'
                    onChange={(page, size) => {
                        setPage(page);
                        setSize(size);
                    }}
                />
            </div>

            <Modal title={modalData.type == 'add' ? '新增' : '修改'} open={modalShow} onOk={save} onCancel={() => setModalShow(false)} okText="提交" cancelText="取消" width={580}>
                <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} onFinish={submit} autoComplete="off" disabled={loading}>
                    <Form.Item label="角色名称" name="name" rules={[{ required: true, message: '名称不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="" name="auth">
                        <Tree checkable onCheck={onCheck} onExpand={onExpand} treeData={treeData} expandedKeys={expandedKeys} checkedKeys={checkedKeys} />
                    </Form.Item>

                </Form>
            </Modal>

            {contextHolder}
        </div>

    )
}
export default Auth;